{
  "version": 1,
  "asset_id": "5a7caec8-840e-4083-ac3c-89bc5be60ec4",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/5a7caec8-840e-4083-ac3c-89bc5be60ec4/raindrop-logo.jpg",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/5a7caec8-840e-4083-ac3c-89bc5be60ec4/raindrop-logo.jpg",
  "original_filename": "raindrop-logo.jpg",
  "size": 97324,
  "content_type": "image/jpeg",
  "created_at": "2026-08-15T17:13:56Z"
}
